module.exports = __webpack_public_path__ + "img/icon_check_commonColor.a0887d7e.svg";